// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar-module__aside__8vndh","collapsed":"Sidebar-module__collapsed__DXroI"};